import React from 'react'
import { Helmet } from 'react-helmet-async' // Added for SEO
import Header from '../Header/Header'
import AutoSlider from '../AutoSlider/AutoSlider'
import Nav from '../Header/Nav'
import Categories from '../Categories/Categories'
import Promos from '../Promos/Promos'
import Products from '../Products/Products'
import WhatssapIcon from './WhatssapIcon'
import AboutSection from '../AboutSection/AboutSection'
import FeaturesSection from '../FeaturesSection/FeaturesSection'
import SocialSection from '../SocialSection/SocialSection'
import Footer from '../Footer/Footer'

const Home = () => {
  return (
    <div id="home" className="scroll-mt-20">
      {/* --- SEO START --- */}
      <Helmet>
        <title>Electro Titan | Électroménager, Climatisation & Équipements de Cuisine à Salé</title>
        <meta key="description" name="description"
    content="Electro Titan est une entreprise de référence dans la vente d’électroménager haut de qualité, alliant innovation, performance et excellence. Nous proposons une sélection rigoureuse d’appareils électroménagers modernes, conçus pour offrir confort, fiabilité et efficacité au quotidien. Grâce à un service client professionnel et des produits au meilleur rapport qualité-prix, Electro Titan accompagne chaque foyer avec des solutions durables, élégantes et adaptées aux exigences modernes. Située à Tabriquet, Salé." />
  <meta name="keywords"
    content="Electro Titan, Titan electro, titanelectro, electrotitan, équipements électriques, appareils électroménagers, import export électrique, maintenance électrique, réparation électroménager, installation électrique, électroménagers a salè, Tabriquet, Salé, Maroc" />
  <meta name="author" content="Electro Titan" />
        
        {/* Open Graph for Facebook/WhatsApp sharing */}
        <meta key="og:title" property="og:title" content="Electro Titan | Électroménager, Climatisation & Équipements de Cuisine à Salé" />
  <meta key="og:description" property="og:description"
    content="Electro Titan – Vente d’électroménager en gros et au détail, de climatisation et d’équipements de cuisine professionnelle à Salé. Produits fiables, marques de qualité et solutions adaptées aux particuliers et aux professionnels.Electro Titan – Vente d’électroménager en gros et au détail, de climatisation et d’équipements de cuisine professionnelle à Salé. Produits fiables, marques de qualité et solutions adaptées aux particuliers et aux professionnels." />
        <meta property="og:url" content="https://www.titanelectro.ma" />
        <meta key="og:type" property="og:type" content="website" />
        
        {/* Local Business Structured Data (JSON-LD) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Electro Titan",
            "image": "https://www.titanelectro.ma/assets/images/logo.png",
            "telephone": "+212640033322",
            "email": "contact@titanelectro.ma",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "8, Avenue allal al arbi al alaoui Hay Salam",
              "addressLocality": "Tabriquet",
              "addressRegion": "Salé",
              "addressCountry": "MA"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+212640033322",
              "contactType": "customer service",
              "areaServed": "MA",
              "availableLanguage": ["French", "Arabic"]
            }
          })}
        </script>
        
      </Helmet>
      {/* --- SEO END --- */}

      <Header />
      <Nav target="home" />
      <AutoSlider />
      <Categories />
      <Promos />
      <Products />
      <WhatssapIcon />
      <AboutSection />
      <FeaturesSection/>
      <SocialSection/>
      <Footer />
    </div>
  )
}

export default Home